import { render, staticRenderFns } from "./script-settings-edit.vue?vue&type=template&id=6f78edb6"
import script from "./script-settings-edit.vue?vue&type=script&lang=js"
export * from "./script-settings-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports